<div class="tab-inner-content">
    <h2>Movement Trial Balance</h2>
    <h5>
      From {{ startDate | date : "MM/d/YYYY" }} to
      {{ endDate | date : "MM/d/YYYY" }}
    </h5>
    <table>
      <tr>
        <th>Account Name</th>
        <!-- <th>Account Type</th> -->
        <th>Opening Debit</th>
        <th>Opening Credit</th>
        <th>Period Debit</th>
        <th>Period Credit</th>
        <th>Closing Debit</th>
        <th>Closing Credit</th>
      </tr>
      <tr class="sub-total" *ngFor="let account of movementTrialBalanceReport?.accounts">
        <td>{{ account.accountName }}</td>
        <!-- <td>{{ account.accountType }}</td> -->
        <td>{{ account.openingDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ account.openingCredit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ account.periodDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ account.periodCredit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ account.closingDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ account.closingCredit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="movementTrialBalanceReport?.accounts?.length !== 0" class="title">
        <td>Total</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalOpeningDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalOpeningCredit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalPeriodDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalPeriodCredit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalClosingDebit | number : "1.2-2" }}</td>
        <td>AED&nbsp;{{ movementTrialBalanceReport?.totalClosingCredit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="movementTrialBalanceReport?.accounts?.length === 0">
        <td colspan="4" class="no-data">
          No data available
        </td>
      </tr>
    </table>
  </div>
  